var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"navigation-button",class:{
    green: _vm.isGreen,
    bookmarked: _vm.isYellow,
    selected: _vm.isSelected,
    red: _vm.isRed,
  },attrs:{"id":`nav-button-${ _vm.flashcardStatus.id }`,"tabindex":"0","data-test":"navigation-button"},on:{"click":_vm.navigate,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();return _vm.navigate.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }